// Vendors
import React, { PropsWithChildren, createContext, useContext, useState } from 'react';
// Enumerations
import { BiometricContextsEnum } from 'enumerations/biometric/biometric.enum';
// Handlers
import { BiometricContextHandlers } from './handlers/biometric.context.handlers';
// Types
import { BiometricContextType } from './types/biometric.context.type';

const BiometricContext = createContext({} as BiometricContextType);

const BiometricProvider = ({ children }: PropsWithChildren): React.JSX.Element => {
  const [currentContext, setCurrentContext] = useState<BiometricContextsEnum | null>(null);
  const [isChallenged, setIsChallenged] = useState<boolean>(false);
  const [challengeCanceled, setChallengeCanceled] = useState<boolean>(false);

  return (
    <BiometricContext.Provider
      value={{
        ...BiometricContextHandlers({
          isChallenged,
          setChallengeCanceled,
        }),
        challengeCanceled,
        currentContext,
        setCurrentContext,
        isChallenged,
        setIsChallenged,
        setChallengeCanceled,
      }}
    >
      {children}
    </BiometricContext.Provider>
  );
};

const useBiometricContext = (): BiometricContextType => useContext(BiometricContext);

export { BiometricProvider, useBiometricContext };
